import script from "./Laboratorio.vue?vue&type=script&setup=true&lang=js"
export * from "./Laboratorio.vue?vue&type=script&setup=true&lang=js"

import "./Laboratorio.vue?vue&type=style&index=0&id=56735744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56735744"]])

export default __exports__